export default "/static/webpack/media/ebber.7d436827.png";